import React from 'react';
import { Alert, LinearProgress, Snackbar, Stack } from '@mui/material';
import { BulkProgressState } from 'organisms/CloudOpsReportAdmin/bulk/types';

export const BulkProgressSnackbar = ({
  progress,
  onDismiss,
}: {
  progress: BulkProgressState | null;
  onDismiss: () => void;
}) => {
  if (!progress) return null;

  let percentage: number | undefined;
  if (progress.total !== undefined && progress.processed !== undefined) {
    percentage =
      progress.total === 0
        ? 0
        : Math.round((progress.processed / progress.total) * 100);
  }
  const showIndeterminateApproval =
    !progress.terminal &&
    progress.phase === 'approving' &&
    percentage === undefined;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={progress.terminal ? 5000 : null}
      onClose={(event, reason) => {
        if (progress.terminal && reason !== 'clickaway') onDismiss();
      }}
    >
      <Alert severity={progress.severity} variant="filled">
        <Stack gap={1} minWidth={320}>
          <span>{progress.message}</span>
          {(percentage !== undefined || showIndeterminateApproval) && (
            <LinearProgress
              variant={
                percentage === undefined ? 'indeterminate' : 'determinate'
              }
              value={percentage}
              aria-label="Bulk report progress"
            />
          )}
        </Stack>
      </Alert>
    </Snackbar>
  );
};
